import { Carousel } from 'antd';
import React, { useEffect } from 'react';

import { Button } from 'ui-components/button/button';
import { useAuthActions } from 'store/auth/use-auth-actions';
import image1 from 'shared/components/assets/Icons/mobile/mobile-login-1.webp';
import image2 from 'shared/components/assets/Icons/mobile/mobile-login-2.webp';
import image3 from 'shared/components/assets/Icons/mobile/mobile-login-3.webp';
import fallback1 from 'shared/components/assets/Icons/mobile/mobile-login-1.avif';
import fallback2 from 'shared/components/assets/Icons/mobile/mobile-login-2.avif';
import fallback3 from 'shared/components/assets/Icons/mobile/mobile-login-3.avif';
import { webViewRedirectLink } from 'features/authentication/utils/utils';
import { ImgWithFallback } from 'features/mobile-report/shared/components/img-with-fallback/img-with-fallback';
import { useRouteParam } from 'hooks/use-query/use-query';
import { webViewTokenSignal } from 'features/mobile-report/state/mobile-report.signals';

import styles from './webview-login.module.scss';

export const WebviewLogin = () => {
    const { loginMobile } = useAuthActions();
    const nextUrl = useRouteParam('next_url') || '';

    useEffect(() => {
        if (webViewTokenSignal.value) {
            loginMobile(webViewTokenSignal.value, webViewTokenSignal.value.next_url || nextUrl);
        }
        //TODO PLAC-55532 - delete after fix eslint & signals issue
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginMobile, nextUrl, webViewTokenSignal.value]);

    return (
        <div className={styles.webviewLogin}>
            <Carousel
                className={styles.carousel}
                dots={{ className: styles.dots }}
                infinite={false}
                lazyLoad="ondemand"
            >
                <div>
                    <ImgWithFallback
                        className={styles.image}
                        src={image1}
                        fallbackSrc={fallback1}
                        alt="Explore"
                    />
                    <h2 className={styles.title}>Explore</h2>
                    <p className={styles.description}>Discover all the properties around you</p>
                </div>
                <div>
                    <ImgWithFallback
                        className={styles.image}
                        src={image2}
                        fallbackSrc={fallback2}
                        alt="Analyze"
                    />
                    <h2 className={styles.title}>Analyze</h2>
                    <p className={styles.description}>
                        Get location insights on the go,
                        <br />
                        anytime, anywhere
                    </p>
                </div>
                <div>
                    <ImgWithFallback
                        className={styles.image}
                        src={image3}
                        fallbackSrc={fallback3}
                        alt="Compare"
                    />
                    <h2 className={styles.title}>Compare</h2>
                    <p className={styles.description}>
                        Benchmark properties against
                        <br />
                        competitors nearby
                    </p>
                </div>
            </Carousel>
            <div className={styles.buttonsContainer}>
                <Button
                    type="brand-primary-full"
                    className={styles.button}
                    href={webViewRedirectLink('/auth/signin?platform=mobile')}
                >
                    Login to Placer ai
                </Button>
                <Button
                    className={styles.button}
                    href={webViewRedirectLink('/auth/signup?platform=mobile')}
                    type="brand-primary"
                >
                    Sign Up
                </Button>
            </div>
        </div>
    );
};
